// Single source of truth — extracted from the Raritan Group Operational Profile PDF.

export const COMPANY = {
  name: "Raritan Group",
  logoTop: "RARITAN",
  logoBottom: "GROUP",
  tagline: "Transforming Urban India through Smart Sanitation, Consultancy & Digital Governance",
  motto: "Smart Solutions. Sustainable Cities. Inclusive Growth.",
  intro:
    "Raritan Group is a multidisciplinary organization working across urban infrastructure, municipal solid waste management, environmental consultancy, digital governance, and community development. Combining consultancy expertise with operational execution, we support Urban Local Bodies, government agencies, institutions, and development stakeholders in building cleaner, more sustainable cities.",
  intro2:
    "Founded to create practical, technology-driven urban solutions, the group unites strategic planning, field implementation, and smart monitoring systems to deliver measurable impact on the ground.",
};

export const IMAGES = {  hero: "https://images.unsplash.com/photo-1535689077097-a8726b5ff822?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGNpdHklMjB0ZWNobm9sb2d5JTIwYWVyaWFsJTIwZ3JlZW58ZW58MHx8fHwxNzg0MTkzNTU2fDA&ixlib=rb-4.1.0&q=85",
  green: "https://images.unsplash.com/photo-1535689077097-a8726b5ff822?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxzbWFydCUyMGNpdHklMjB0ZWNobm9sb2d5JTIwYWVyaWFsJTIwZ3JlZW58ZW58MHx8fHwxNzg0MTkzNTU2fDA&ixlib=rb-4.1.0&q=85",
  smart: "https://images.unsplash.com/photo-1760553120312-2821bf54e767?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxzbWFydCUyMGNpdHklMjB0ZWNobm9sb2d5JTIwYWVyaWFsJTIwZ3JlZW58ZW58MHx8fHwxNzg0MTkzNTU2fDA&ixlib=rb-4.1.0&q=85",
  leadership: "https://images.unsplash.com/photo-1573164574572-cb89e39749b4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxwcmVtaXVtJTIwY29ycG9yYXRlJTIwbGVhZGVyc2hpcCUyMG1lZXRpbmd8ZW58MHx8fHwxNzg0MTkzNTU2fDA&ixlib=rb-4.1.0&q=85",
};

export const LOGOS = {
  consulting: "/logo-consulting.png",
  foundation: "/logo-foundation.png",
};

export const ENTITIES = [
  {
    id: "consulting",
    name: "Raritan Consulting & Information Services India Pvt. Ltd.",
    short: "Raritan Consulting",
    role: "Technical & Operational Arm",
    logo: "/logo-consulting.png",
    desc: "The technical and operational engine of the ecosystem — delivering consultancy, digital governance systems, smart collection, and scientific waste processing from planning through execution.",
  },
  {
    id: "foundation",
    name: "Raritan Karmanya Foundation",
    short: "Karmanya Foundation",
    role: "Social Impact Arm",
    logo: "/logo-foundation.png",
    desc: "Focused on awareness generation, social inclusion, and community welfare — ensuring sanitation systems succeed through behavioral change and community participation.",
  },
];

export const VISION =
  "To become a nationally trusted organization delivering innovative, sustainable, and technology-enabled urban solutions that improve quality of life and strengthen environmental resilience.";

export const MISSION =
  "Raritan Group bridges the gap between planning and implementation by integrating consultancy, technology, manpower, and field execution under one ecosystem — committed to helping cities achieve scientific waste management, efficient governance systems, and inclusive development.";

export const VALUES = [
  { title: "Integrity", desc: "Transparent, accountable, and ethical operations." },
  { title: "Innovation", desc: "Technology-driven and data-backed decision making." },
  { title: "Sustainability", desc: "Long-term environmental and operational impact." },
  { title: "Inclusion", desc: "Empowering communities and sanitation workers." },
  { title: "Excellence", desc: "Quality-driven solutions with measurable outcomes." },
];

export const WHY_US = [
  { title: "End-to-End Capability", desc: "From project planning and DPR preparation to operational execution and monitoring." },
  { title: "Technology-Driven Systems", desc: "GPS, RFID, IoT, MIS, and digital governance tools for operational transparency." },
  { title: "Strong Govt Understanding", desc: "Deep experience with Urban Local Bodies, sanitation missions, and compliance frameworks." },
  { title: "Multi-Disciplinary Expertise", desc: "Management consultancy, environmental planning, IT systems, and operational execution combined." },
  { title: "Sustainable & Inclusive", desc: "Balancing environmental sustainability with social impact and community participation." },
];

export const SERVICE_GROUPS = [
  {
    id: "consultancy",
    tag: "01",
    title: "Management Consultancy",
    lead: "Strategic Consultancy for Sustainable Cities",
    desc: "End-to-end management consultancy for urban local bodies, institutions, and development agencies — technically sound, financially viable, and implementation-oriented from planning to monitoring.",
    items: [
      { name: "Detailed Project Reports (DPRs)", points: ["Fresh waste management systems", "Legacy waste remediation projects", "Material Recovery Facilities (MRFs)", "Processing plants & smart sanitation infrastructure"] },
      { name: "RFP & Tender Consultancy", points: ["Milestone-based RFPs", "Tender documentation support", "Technical bid assistance", "PPP & DBFOT structuring", "Bid evaluation assistance"] },
      { name: "Survey & Assessment Studies", points: ["Bulk Waste Generator (BWG) mapping", "Waste characterization studies", "Household surveys", "GIS-based mapping", "Urban sanitation assessments"] },
      { name: "Technical & Management Consultancy", points: ["Urban governance advisory", "Municipal operational planning", "Monitoring & evaluation systems", "Environmental compliance support", "Capacity building & institutional strengthening"] },
    ],
  },
  {
    id: "digital",
    tag: "02",
    title: "IT & Digital Governance",
    lead: "Digitizing Urban Governance",
    desc: "Advanced digital systems and smart technologies integrated into urban management and sanitation operations — improving transparency, efficiency, and accountability aligned with national missions.",
    items: [
      { name: "MIS & Portal Management", points: ["Swachhatam Portal management", "Real-time progress monitoring", "Digital reporting systems", "Dashboard preparation", "Data analytics & compliance tracking"] },
      { name: "Smart Monitoring Systems", points: ["GPS-enabled fleet tracking", "RFID-based collection systems", "Geo-tagged attendance systems", "AI-supported operational monitoring"] },
      { name: "Swachh Survekshan Support", points: ["ODF / ODF+ / ODF++", "Documentation & evidence management", "Field verification coordination", "Garbage Free City (GFC) Star Ratings", "Citizen feedback systems"] },
      { name: "IT Infrastructure Support", points: ["Software & digital systems support", "Data management systems", "Control room setup assistance", "Operational reporting frameworks"] },
    ],
  },
  {
    id: "collection",
    tag: "03",
    title: "Smart Collection Systems",
    lead: "Technology-Driven Waste Collection",
    desc: "Technology, manpower, and mechanized systems combined for efficient, accountable sanitation operations — improving collection efficiency, route optimization, transparency, and monitoring.",
    items: [
      { name: "RFID-Based Collection Monitoring", points: ["Real-time collection verification", "Timestamp-based monitoring", "Collection tracking & accountability", "Digital attendance & reporting"] },
      { name: "GPS-Based Fleet Management", points: ["Route optimization", "Vehicle tracking", "Fuel efficiency monitoring", "Real-time operational visibility"] },
      { name: "IoT Smart Monitoring", points: ["Smart bin monitoring", "Fill-level detection", "Automated collection alerts", "Data-based operational planning"] },
    ],
  },
  {
    id: "processing",
    tag: "04",
    title: "Waste Processing Solutions",
    lead: "Scientific Waste Processing & Land Reclamation",
    desc: "Environmentally sustainable, scientifically managed waste processing supporting circular-economy principles and urban environmental restoration — reducing landfill dependency while promoting resource recovery.",
    items: [
      { name: "Legacy Waste Bio-remediation", points: ["Bio-mining of legacy dumpsites", "Scientific waste segregation", "Land reclamation activities", "Environmental restoration"] },
      { name: "Fresh Waste Management", points: ["Wet waste processing", "Dry waste segregation", "Composting operations", "Resource recovery systems", "Scientific transportation & disposal"] },
      { name: "Material Recovery Facilities (MRFs)", points: ["Plastic recovery", "Paper & cardboard", "Metal segregation", "Dry waste channelization"] },
      { name: "Green & Sustainable Initiatives", points: ["Miyawaki plantation projects", "Urban green belt development", "Environmental awareness", "Sustainable urban landscape"] },
    ],
  },
  {
    id: "social",
    tag: "05",
    title: "Social Inclusion",
    lead: "Empowering Communities Through Inclusion",
    desc: "Delivered by Raritan Karmanya Foundation — creating awareness, strengthening community participation, and supporting vulnerable groups linked to sanitation and urban livelihoods.",
    items: [
      { name: "IEC & Behavioral Change Campaigns", points: ["Door-to-door campaigns", "Community outreach", "Public participation initiatives", "Source segregation drives", "School awareness"] },
      { name: "Workforce Inclusion", points: ["Livelihood integration", "Skill development", "Social security", "Occupational health", "Welfare schemes"] },
      { name: "CSR & Sustainability", points: ["Environmental awareness", "Community development", "Sustainability drives", "Social impact projects"] },
    ],
  },
];

export const LEADERS = [
  {
    name: "Aman Kumar",
    title: "Director & Strategic Operations Lead",
    initials: "AK",
    photo: "/dir-aman.webp",
    objectPos: "center 15%",
    bio: "Leads operational planning, strategic implementation, stakeholder coordination, and execution management across urban sanitation and infrastructure projects — ensuring operational efficiency, timely delivery, and sustainable outcomes.",
    focus: ["Strategic Operations", "Execution Management", "Stakeholder Coordination"],
  },
  {
    name: "Rewant Raj",
    title: "Director — Management Consultancy & Digital Governance",
    initials: "RR",
    photo: "/dir-rewant.webp",
    objectPos: "center center",
    zoom: 1.85,
    origin: "72% 48%",
    bio: "Specializes in urban management consultancy, DPR preparation, digital governance systems, Swachh Survekshan support, MIS management, documentation, and policy coordination, with extensive experience supporting Urban Local Bodies.",
    focus: ["Consultancy", "Digital Governance", "Swachh Survekshan"],
  },
  {
    name: "Kumar Gautam",
    title: "Director — Field Operations & Infrastructure Management",
    initials: "KG",
    photo: "/dir-gautam.jpeg",
    objectPos: "center 20%",
    bio: "Oversees field operations, waste processing systems, manpower deployment, machinery coordination, and project monitoring — ensuring smooth execution and effective management of large-scale sanitation activities.",
    focus: ["Field Operations", "Waste Processing", "Project Monitoring"],
  },
];

export const PROJECTS = [
  { id: "01", name: "Nagar Nigam Roorkee", area: "Documentation & Field Coordination", desc: "Swachh Survekshan documentation support, field activity coordination, and urban sanitation framework planning.", state: "Uttarakhand" },
  { id: "02", name: "Nagar Palika Parishad Kichha", area: "DPR Preparation & RFP Consultancy", desc: "Detailed Project Report preparation, RFP consultancy design, and strategic urban management systems support.", state: "Uttarakhand" },
  { id: "03", name: "Sitarganj & Tehri", area: "MIS Support & Evaluation", desc: "MIS management coordination, Swachh Survekshan certification compliance, and monitoring & evaluation frameworks.", state: "Uttarakhand" },
  { id: "04", name: "Manglaur & Other ULBs", area: "Sanitation & Digital Governance", desc: "Urban sanitation consultancy, operational support systems implementation, and digital governance technology assistance.", state: "Uttarakhand" },
];

export const FOOTPRINT = ["Uttarakhand", "Uttar Pradesh", "Haryana", "Bihar", "Delhi NCR"];

export const TECH = [
  { name: "GPS", desc: "Fleet tracking & route optimization" },
  { name: "RFID", desc: "Household collection verification" },
  { name: "IoT", desc: "Smart bins & fill-level detection" },
  { name: "MIS", desc: "Dashboards & compliance tracking" },
  { name: "AI", desc: "Operational monitoring & analytics" },
];

export const ROADMAP = [
  { no: "01", title: "AI-Driven Monitoring", desc: "Deploying cutting-edge AI-driven monitoring systems for operations." },
  { no: "02", title: "Smart City Sanitation", desc: "Expanding sophisticated smart-city sanitation solutions nationwide." },
  { no: "03", title: "Advanced Waste Tech", desc: "Pioneering scientific, advanced waste-processing technologies." },
  { no: "04", title: "Climate & Social Scale", desc: "Climate-resilient urban infrastructure, expanded social inclusion & national-level consultancy projects." },
];

export const ROADMAP_COMMITMENT =
  "Creating cleaner cities, empowered communities, and sustainable urban ecosystems for the future.";

export const STATS = [
  { value: 5, suffix: "+", label: "States of operational presence" },
  { value: 6, suffix: "+", label: "Urban Local Bodies engaged" },
  { value: 5, suffix: "", label: "Integrated service verticals" },
  { value: 2, suffix: "", label: "Entities under one ecosystem" },
];

export const CONTACT = {
  office: "131/9, GF, Kishangarh, Vasant Kunj, New Delhi – 110070",
  phones: ["+91-8292021478", "+91-7836032547"],
  emails: ["raritanconsulting@gmail.com", "raritankarmanyafoundation@gmail.com"],
};

export const FOUNDATION_ACTIVITIES = [
  { title: "IEC & Behavioral Change Campaigns", desc: "Door-to-door campaigns, community outreach, public participation initiatives, source segregation drives, and school awareness programs." },
  { title: "Workforce Inclusion", desc: "Livelihood integration, skill development, social security, occupational health, and welfare schemes for sanitation workers." },
  { title: "CSR & Sustainability", desc: "Collaborations for environmental awareness, community development, sustainability drives, and social impact projects." },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Services", to: "/services" },
  { label: "Projects", to: "/projects" },
  { label: "Activities", to: "/activities" },
  { label: "Leadership", to: "/leadership" },
  { label: "Foundation", to: "/foundation" },
  { label: "Media", to: "/media" },
  { label: "Roadmap", to: "/roadmap" },
  { label: "Contact", to: "/contact" },
];

export const ACTIVITIES = [
  {
    id: "01",
    tag: "Community · Mass Mobilization",
    title: "Swachhata Hi Seva Rallies",
    lead: "Human chain forming India's map. 5,000+ citizens. One pledge.",
    desc: "Every Swachhata Hi Seva fortnight, Raritan Consulting mobilizes citizens, students, and sanitation workers into city-wide rallies. From forming the map of India as a human chain at Nehru Stadium to leading processions through the historic quarters of Roorkee, these mobilizations turn abstract policy into visible, shared civic commitment.",
    highlights: ["Human-chain India map", "Multi-ward city processions", "Coordinated with Nagar Nigam"],
    image: "/act-rally-map.jpg",
    imageAlt: "Human chain forming India's map at Nehru Stadium",
    accent: "green",
  },
  {
    id: "02",
    tag: "Youth · Creative Engagement",
    title: "Drawing & Painting Competitions",
    lead: "Where young hands imagine a cleaner India.",
    desc: "Poster and painting contests in government and private schools invite students to visualize a Swachh Bharat — from swachhata symbols and Gandhi tributes to smart-city landscapes. The competitions culminate in a public showcase at Swachhotsav events with Nigam officials and school leadership as judges.",
    highlights: ["Held across 12+ schools", "Themed on Swachh Bharat", "Winners felicitated at Swachhotsav"],
    image: "/act-drawing-2.jpg",
    imageAlt: "Girls at Kanya Pathshala Inter College displaying their Swachh Bharat paintings",
    accent: "red",
  },
  {
    id: "03",
    tag: "Environment · Green Cover",
    title: "Plantation & Miyawaki Drives",
    lead: "Every child, one sapling.",
    desc: "Ward-level and school plantation drives across Roorkee, timed with Harela festival and Van Mahotsav. Raritan Consulting coordinates sapling supply, site preparation, and post-plantation monitoring — including Miyawaki dense-forest pilots for rapid green-cover restoration in urban pockets.",
    highlights: ["Harela festival plantation", "Miyawaki dense-forest pilots", "School-led green pledges"],
    image: "/act-plantation.jpg",
    imageAlt: "School children planting saplings in pots",
    accent: "green",
  },
  {
    id: "04",
    tag: "Behavioral Change · IEC",
    title: "Source Segregation Workshops",
    lead: "Turning wet, dry, and hazardous into habit.",
    desc: "Door-to-door and ward-level workshops teach households to segregate at source and hand waste only to Nigam vehicles. Combined with dengue & malaria prevention drives, these workshops sit at the heart of India's Swachh Survekshan compliance framework.",
    highlights: ["Ward 15 & 20 Sainik Colony", "Wards 18 & 30 Amber Talab", "Household-level engagement"],
    image: "/media-7.jpg",
    imageAlt: "Community source-segregation workshop in Sainik Colony",
    accent: "red",
  },
  {
    id: "05",
    tag: "Public Health · School Outreach",
    title: "School Awareness Programs",
    lead: "Cleanliness taught, not preached.",
    desc: "Awareness sessions in schools and colleges — Methodist Girls College, Arya Kanya Pathshala Inter College, Jain Inter College and more — cover mosquito-borne disease prevention, hygiene, and civic responsibility, delivered by Raritan Consulting's field team alongside brand ambassadors.",
    highlights: ["Methodist Girls College", "Arya Kanya Pathshala", "Greenway Modern School"],
    image: "/act-drawing-1.jpg",
    imageAlt: "Students at a Swachh Bharat awareness workshop",
    accent: "green",
  },
  {
    id: "06",
    tag: "Health · Worker Welfare",
    title: "Sanitation Worker Health Camps",
    lead: "Because those who clean the city deserve care first.",
    desc: "Free health check-up camps and medical-kit distributions for sanitation workers of the Nagar Nigam. Coordinated with Nigam leadership, these camps have become an annual fixture — a reminder that scientific waste management begins with worker welfare.",
    highlights: ["Free medical check-ups", "Medical kits distributed", "Anchored by the Mayor's office"],
    image: "/media-1.jpg",
    imageAlt: "Medical kits handed out to sanitation workers",
    accent: "red",
  },
];

export const ACTIVITY_GALLERY = [
  { src: "/act-swachhata-2026.jpg", caption: "'Swachhata Hi Sewa 2026' — students spell out the campaign" },
  { src: "/act-rally-map.jpg", caption: "Human chain — Map of India" },
  { src: "/act-dengue-banner.jpg", caption: "Dengue prevention school banner walk" },
  { src: "/act-rally-street.jpg", caption: "Swachhata Hi Seva city procession" },
  { src: "/act-drawing-1.jpg", caption: "Drawing competition, Kanya Pathshala" },
  { src: "/act-slogan-swachhbharat.jpg", caption: "A young student's Swachh Bharat pledge" },
  { src: "/act-drawing-2.jpg", caption: "Swachhotsav 2025 — poster showcase" },
  { src: "/act-slogan-hygiene.jpg", caption: "'Hygiene is there when cleanliness is in air'" },
  { src: "/act-slogan-sanskaar.jpg", caption: "'Swabhaav Swachhata, Sanskaar Swachhata'" },
  { src: "/act-plantation.jpg", caption: "School plantation drive" },
  { src: "/act-campus-plantation.jpg", caption: "Green-campus plantation, Greenway Modern" },
  { src: "/media-7.jpg", caption: "Sainik Colony source-segregation workshop" },
  { src: "/media-8.jpg", caption: "Arya Kanya Pathshala school awareness" },
  { src: "/media-5.jpg", caption: "Harela festival plantation" },
];

export const ACTIVITY_STATS = [
  { value: 12, suffix: "+", label: "Schools & colleges engaged" },
  { value: 30, suffix: "+", label: "Ward-level workshops" },
  { value: 5000, suffix: "+", label: "Citizens mobilized in rallies" },
  { value: 500, suffix: "+", label: "Saplings planted" },
];

export const MEDIA = [
  {
    id: "01",
    image: "/media-1.jpg",
    title: "Medical Kits Distributed to Sanitation Workers",
    summary:
      "Health check-up camp and medical-kit distribution drive for sanitation workers at Nagar Nigam Roorkee — organized under Raritan Consulting's field coordination, in partnership with the Mayor's office.",
    tag: "Health · Sanitation Workers",
    location: "Nagar Nigam Roorkee",
    publication: "Janwani",
    period: "Swachhotsav — Sep–Oct",
  },
  {
    id: "02",
    image: "/media-2.jpg",
    title: "Mayor: Workers' Health is the Corporation's Responsibility",
    summary:
      "Mayor Anita Agrawal underlines the Corporation's commitment to worker welfare during a health-camp organized by Raritan Consulting, with medical checks and kits handed out to sanitation staff.",
    tag: "Welfare · Behavioral Change",
    location: "Nagar Nigam Roorkee",
    publication: "Janwani",
    period: "Swachhotsav",
  },
  {
    id: "03",
    image: "/media-3.jpg",
    title: "Human Chain Forms the Map of India",
    summary:
      "A city-wide 'Swachhata Hi Seva' rally culminated at Nehru Stadium where a human chain formed the map of India — a mass pledge for cleanliness, coordinated with Raritan Consulting.",
    tag: "Community · Awareness",
    location: "Nehru Stadium, Roorkee",
    publication: "Local Press",
    period: "Sep 2025",
  },
  {
    id: "04",
    image: "/media-4.jpg",
    title: "Dengue & Malaria Prevention Workshops in Wards",
    summary:
      "Raritan Consulting team conducted ward-level workshops on dengue & malaria prevention — source-segregation drives, cleanliness advocacy, and citizen engagement across sectors of Roorkee.",
    tag: "Public Health · IEC",
    location: "Wards 15 & 20, Roorkee",
    publication: "Local Press",
    period: "Aug 2026",
  },
  {
    id: "05",
    image: "/media-5.jpg",
    title: "Harela Festival Celebrated with Plantation Drive",
    summary:
      "Nagar Nigam Roorkee celebrated Uttarakhand's Harela festival with a plantation drive across every ward — a green-cover pledge for the education city, coordinated by Raritan Consulting.",
    tag: "Environment · Green Cover",
    location: "Adarsh Nagar, Roorkee",
    publication: "Janwani",
    period: "Aug 2026",
  },
  {
    id: "06",
    image: "/media-6.jpg",
    title: "Dengue & Malaria Awareness at Methodist Girls College",
    summary:
      "Raritan Consulting and Nagar Nigam Roorkee ran a girl-students awareness workshop at Methodist Girls College on mosquito-borne disease prevention, hygiene, and stagnant-water control — followed by a plantation drive at Jain Inter College.",
    tag: "Youth Awareness · School Engagement",
    location: "Methodist Girls College, Roorkee",
    publication: "Local Press",
    period: "Aug 2026",
  },
  {
    id: "07",
    image: "/media-7.jpg",
    title: "Cleanliness is Key to Staying Healthy",
    summary:
      "Ward-level workshop at Sainik Colony (Wards 15 & 20) on dengue & malaria prevention and source segregation — Raritan Consulting mobilized citizens to hand household waste only to Nigam vehicles and adopt daily hygiene practices.",
    tag: "Community · Source Segregation",
    location: "Sainik Colony, Roorkee",
    publication: "Janwani",
    period: "Aug 2026",
  },
  {
    id: "08",
    image: "/media-8.jpg",
    title: "Mosquito-borne Disease Awareness in Schools",
    summary:
      "Awareness programs across Ward 18 Ganeshpur & Ward 30 Paschimi Amber Talab — Raritan Consulting's Priyanka and brand ambassador Savitri Mangla led students at Arya Kanya Pathshala on dengue/malaria prevention, hand-washing, and waste segregation.",
    tag: "School Outreach · Public Health",
    location: "Arya Kanya Pathshala, Roorkee",
    publication: "Jagran",
    period: "Aug 2026",
  },
  {
    id: "09",
    image: "/media-9.jpg",
    title: "Ward 26 Awas Vikas Source-Segregation Workshop",
    summary:
      "Under Swachhata Hi Seva, Nagar Nigam Roorkee held a citizens' workshop in Ward 26 Awas Vikas on segregating waste into four streams (wet, dry, sanitary, hazardous) and handing garbage only to Nigam vehicles — led with Raritan Consulting's Priyanka, Ejaz, Priya Saini and Amit Kumar.",
    tag: "Behavioral Change · Ward Outreach",
    location: "Ward 26 Awas Vikas, Roorkee",
    publication: "Jagran",
    period: "Sep 2026",
  },
  {
    id: "10",
    image: "/media-10.jpg",
    title: "Cleanliness Drives & Manav Shrinkhala for Swachh Roorkee",
    summary:
      "Under Swachhata Hi Seva Sankalp 2026, the Nigam ran cleanliness drives along PWD Road, Delhi Road, Solani Park and the Haridwar Highway. In parallel, students at Aashu Public Inter College formed a human chain — Manav Shrinkhala — and pledged to keep the city clean.",
    tag: "Community · Mass Mobilization",
    location: "PWD Road & Aashu Inter College, Roorkee",
    publication: "Jagran",
    period: "Sep 2026",
  },
];
